/* unplugin-vue-components disabled */import { render } from "./Footer.vue?vue&type=template&id=77070011&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=77070011&lang=scss&scoped=true"

import exportComponent from "E:\\普通网页项目\\奇力士官网新版\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77070011"]])

export default __exports__